module.exports = __webpack_public_path__ + "static/media/licence1.ee53e8d9.png";